

















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import PermissionTree from '../../../components/permissionTree.vue'
import AbpBase from '../../../lib/abpbase'
import Role from '@/store/entities/role';
@Component({
    components: { PermissionTree }
})
export default class CreateRole extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Array}) roleTypes:any;
    @Prop({type:Array}) tree:any;
    role:Role=new Role();
    copyRole={};
    selectPermissions:any[];
    get permissions(){
        return this.$store.state.role.permissions
    }
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                let copyRole = JSON.parse(JSON.stringify(this.role))
                if (this.selectPermissions && this.selectPermissions.length >= 0) {
                    copyRole.permissions = this.selectPermissions
                }
                if(!this.role.permissions){
                    this.role.permissions=[];
                }
                let id:any = await this.$store.dispatch({
                    type:'role/create',
                    data:copyRole
                });
                (this.$refs.roleForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
                this.$emit('creatmenu',(this.$refs.perTree as any).getCheckedNodes(),id.data.result.id)
            }
        })
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    checkChange(value:any[]) {
        this.selectPermissions = value
    }
    roleRule={
        name:[{required: true,message:'角色名称不能为空',trigger: 'blur'}],
        displayName:[{required: true,message:'显示名称不能为空',trigger: 'blur'}]
    }
}
